module.exports = __webpack_public_path__ + "static/media/userimg.50132f29.jpg";